import { createElement, Component, PropTypes } from 'rlink-react';
import RecruitingJob from 'rlink-recruiting/RecruitingJob';
import groupJobsByDepartment from 'rlink-recruiting/groupJobsByDepartment';
import spliceJobPostings from 'rlink-recruiting/spliceJobPostings';
import NavLink from 'rlink-router/NavLink';
import themeable from 'rlink-theme/themeable';

import CategorizedJobs from 'components/Careers/CategorizedJobs';
import careersScene from 'helpers/scenes/careersScene';
import getArticleLoader from 'helpers/getArticleLoader';

const DEPARTMENTS_PER_ROW = 3;

export default class CareersPanel extends Component {
  hasJobPostings () {
    return this.props.jobPostings && this.props.jobPostings.length > 0;
  }

  initCareerScene () {
    if (this.hasJobPostings()) {
      careersScene();
    }
  }

  componentDidUpdate () {
    this.initCareerScene();
  }

  componentDidMount () {
    this.initCareerScene();
  }

  render () {
    const { theme, jobPostings, careersCopy } = this.props;
    const groupedJobPostings = spliceJobPostings(
      groupJobsByDepartment(jobPostings),
      DEPARTMENTS_PER_ROW
    );
    return (
      <section className="node node-single-page-section node-promoted view-mode-full">
        <article id="careers" className="layout-text bg-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Careers</h2>
              <div className={theme.CandidateNoticeLink} dangerouslySetInnerHTML={{__html: careersCopy}} />
            </div>
          </div>
        </article>
        <article id="current-vacancies" className="layout-standard text-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Current Vacancies</h2>
              <div className="view view-job-positions view-id-job_positions view-display-id-job_directory view-dom-id-9a8d3df4af0440d1debae513c70fd82e">
                <div className="view-content">
                  {groupedJobPostings.map(jobRow => (
                    <div key={JSON.stringify(jobRow)} className="row">
                      {Object.entries(jobRow).map(([department, jobs]) => (
                        <CategorizedJobs
                          key={department}
                          category={department}
                          jobs={jobs} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

CareersPanel.propTypes = {
  careersCopy: PropTypes.string,
  jobPostings: PropTypes.arrayOf(PropTypes.instanceOf(RecruitingJob)),
};

themeable(CareersPanel, {
  classes: [
    'CandidateNoticeLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CareersPanel.jsx